import { createFileRoute } from "@tanstack/react-router";
import Calculator from "../../../../pages/Calculator";

// Console search: metered against the subscription quota, with full-year support.
export const Route = createFileRoute("/_app/account/konsoll/")({
	component: () => <Calculator metered allowYear />,
});
